import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import { notificarError } from "../Almacenes/AlmacenNotify";

class ProductosProduccion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productos: [],
            loading: true,
            error: null,
            pages: 0,
            pageSize: 10,
            page: 0,
            sorted: [],
            filtered: []
        };
    }

    async listProductos(page=0, pageSize=10) {
        this.setState({loading: true, error: null});
        try {
            const response = await fetch(`/api/productosProduccion/filter?page=${page}&pageSize=${pageSize}`);
            if (!response.ok) {
                throw new Error(`Error fetching productos: ${response.statusText}`);
            }

            const data = await response.json();

            this.setState({
                productos: data.productos, 
                loading: false,
                pages: data.pagination.totalPages,
                pageSize: data.pagination.pageSize,
                page: data.pagination.currentPage
                
            });
        } catch (error) {
            this.setState({error: error.message, loading: false});
            notificarError(`Error loading productos: ${error.message}`);
        }
    }

    componentDidMount() {
        this.listProductos();
    }

    handleFetchData = (state) => {
        this.setState({
            page: state.page,
            pageSize: state.pageSize,
            sorted: state.sorted,
            filtered: state.filtered
        });


        this.listProductos(state.page, state.pageSize);
    }

    async onFilterProds(state, instance) {
        this.setState({loading: true});
        
        const params = {
            page: state.page,
            pageSize: state.pageSize,
            sorted: state.sorted,
            filtered: state.filtered
        };

        try {
            const response = await fetch('/api/productosProduccion/filter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params)
            });
            
            if (!response.ok) {
                throw new Error(`Error filtering productos: ${response.statusText}`);
            }
            
            const prods = await response.json();
            const prodsClean = prods.productos.filter(x => x);
            
            if (prodsClean) {
                this.setState({
                    productos: prodsClean,
                    pages: prods.pages,
                    page: state.page,
                    pageSize: state.pageSize,
                    sorted: state.sorted,
                    filtered: state.filtered,
                    loading: false
                });
            } else {
                notificarError("No se ha podido filtrar los productos");
                this.setState({loading: false});
            }
        } catch (error) {
            this.setState({error: error.message, loading: false});
            notificarError(`Error filtering productos: ${error.message}`);
        }
    }

    render() {
        const { productos, loading, pages, pageSize } = this.state;

        return (
            <div>
                <section className="ventas-fpay-section-vh pt-5">
                    <div className="container">
                        <ReactTable 
                            id="table-productos-to-xls"
                            data={productos}
                            pages={pages}
                            loading={loading}
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]) === filter.value
                            }
                            manual={true}
                            onFetchData={this.handleFetchData}
                            filterable={true}
                            sortable={true}
                            columns={[
                                {
                                    columns: [
                                        {
                                            Header: 'Código',
                                            accessor: 'Codigo',
                                            width: 120,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Codigo"] }),
                                            filterAll: true,
                                        },
                                        {
                                            Header: 'Nombre',
                                            accessor: 'Nombre',
                                            minWidth: 250,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Nombre"] }),
                                            filterAll: true,
                                        },
                                        {
                                            Header: 'Categoria',
                                            accessor: 'Categoria',
                                            minWidth: 120,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Categoria"] }),
                                            filterAll: true,
                                        },
                                        
                                        {
                                            Header: 'Unidad',
                                            accessor: 'Unidad',
                                            width: 150,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Unidad"] }),
                                            filterAll: true,
                                        },
                                        {
                                            Header: 'Estado',
                                            accessor: 'Estado',
                                            width: 120,
                                            filterMethod: (filter, row) => {
                                                if (filter.value === "all") {
                                                    return true;
                                                }
                                                return row[filter.id] === filter.value;
                                            },
                                            Filter: ({ filter, onChange }) => (
                                                <select
                                                    onChange={event => onChange(event.target.value)}
                                                    style={{ width: "100%" }}
                                                    value={filter ? filter.value : "all"}
                                                >
                                                    <option value="all">Todos</option>
                                                    <option value="ACTIVO">ACTIVO</option>
                                                    <option value="INACTIVO">INACTIVO</option>
                                                </select>
                                            ),
                                            Cell: ({ value }) => (
                                                <span
                                                    className={`badge ${
                                                        value === 'ACTIVO' 
                                                            ? 'badge-success' 
                                                            : 'badge-danger'
                                                    }`}
                                                >
                                                    {value}
                                                </span>
                                            )
                                        }
                                    ]
                                }
                            ]}
                            defaultPageSize={5}
                            className="-striped -highlight"
                            previousText="Anterior"
                            nextText="Siguiente"
                            noDataText="No se encontraron registros"
                            loadingText="Cargando..."
                            ofText="de"
                            rowsText="filas"
                            pageText="Página"
                            pageSizeOptions={[10, 20, 25, 50, 100]}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

export default ProductosProduccion;